/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var Ladda = require('ladda');

var SecCompRegFormView = require('./SecCompRegFormView');
var tmplSecExtCompRegNewView = require('../templates/SecExtCompRegNewView.hbs');
var SubmitUserComplianceRegistration = require('../services/SubmitUserComplianceRegistration');
var SecCompRegPaymentView = require('./SecCompRegPaymentView');

require('../styles/SecExtCompRegNewView.css');

module.exports = Marionette.LayoutView.extend({
  template: tmplSecExtCompRegNewView,

  className: 'sec-ext-compliance-registration-new-view container-fluid',

  ui: {
    complianceRegistrationForm: '.compliance-registration-form-container',
    affirmationForm: '.affirmation-form',
    submit: '.btn-submit',
    complianceRegistrationTab: '.compliance-registration-tab',
    complianceRegistrationTabPanel: '.compliance-registration-tab-panel',
    paymentTab: '.payment-tab',
    paymentContainer: '.payment-container'
  },

  regions: {
    complianceRegistrationForm: '@ui.complianceRegistrationForm',
    paymentContainer: '@ui.paymentContainer'
  },

  events: {
    'click @ui.submit': 'onClickSubmit'
  },

  onBeforeShow: function() {
    this.complianceRegistrationForm = new SecCompRegFormView({
      model: this.model
    });

    this.showChildView('complianceRegistrationForm', this.complianceRegistrationForm);
  },

  onClickSubmit: function(e) {
    e.preventDefault();
    var self = this;
    this.validate().done(
      function() {
        var laddaContext = Ladda.create(this.ui.submit.get(0));
        laddaContext.start();
        var formData = this.getFormData();
        formData.isPaid = 0;
        formData.isInternal = 0;
        SubmitUserComplianceRegistration(formData)
          .done(function(id) {
            self.showChildView(
              'paymentContainer',
              new SecCompRegPaymentView({
                viewMode: 'new',
                model: new Backbone.Model({
                  id: id,
                  invoiceItems: [
                    {
                      description: 'Compliance Registration Fee',
                      quantity: 1,
                      unitPrice: self.model.get('registrationFee')
                    }
                  ]
                })
              })
            );
            self.ui.paymentTab.tab('show');
            self.ui.complianceRegistrationTabPanel.removeClass('active');
            self.ui.paymentContainer.addClass('active');
            laddaContext.stop();
          })
          .fail(function() {
            laddaContext.stop();
          });
      }.bind(this)
    );
  },

  validate: function() {
    var validationPromises = [
      this.ui.complianceRegistrationForm.parsley().whenValidate(),
      this.ui.affirmationForm.parsley().whenValidate()
    ];
    return $.when.apply($, validationPromises);
  },

  getFormData: function() {
    var formData = this.complianceRegistrationForm.getFormData();
    return formData;
  }
});
